import type { FC } from 'react'
import styled from 'styled-components'

import type { Document } from '@/lib/apollo/query/get-applicant'

interface Props {
  document: Document
}

const StyledImg = styled.img`
  max-width: 50px;
  max-height: 50px;
`

const Container = styled.div`
  display: grid;
  grid-template-columns: min-content 1fr;
  gap: 10px;
  align-items: center;
`

const PreviewDocument: FC<Props> = ({ document }) => (
  <Container>
    <StyledImg src={document.fileName} alt="evidence" />
    {document.type}
  </Container>
)

export default PreviewDocument
